import { AxiosError, AxiosRequestConfig } from 'axios';

export { default as smt } from './smt';
export { default as useAuth } from './useAuth';
export { default as useFetch } from './useFetch';
export { default as useRequest } from './useRequest';

export type RequestError<T> = AxiosError<T>;

export type RequestConfig<T> = AxiosRequestConfig & {
  onSuccess?: (data: T) => void;
  onError?: (err: RequestError<T>) => void;
  onCancel?: (mounted: boolean) => void;
  onComplete?: () => void;
};

export type { CancelTokenSource } from 'axios';

export type AuthStatus = 'loggedOut' | 'creating' | 'loggedIn' | 'refreshing' | 'error';

export type AuthResponse = {
  dataType: string;
  data: string;
  remaining: number;
};

export type Auth = {
  status: AuthStatus;
  token?: string | null;
  userId?: string;
  validation?: 'phone';
  setToken: (token: string | null) => void;
};
